var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconHospital = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_-_hospital",
    "data-name": "Icon - hospital",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 13.714,
    viewBox: "0 0 12 13.714",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "hospital",
    d: "M4.821,9.429H3.75a.321.321,0,0,1-.321-.321V8.036a.321.321,0,0,1,.321-.321H4.821a.321.321,0,0,1,.321.321V9.107A.321.321,0,0,1,4.821,9.429Zm2.357,0H8.25a.321.321,0,0,0,.321-.321V8.036a.321.321,0,0,0-.321-.321H7.179a.321.321,0,0,0-.321.321V9.107A.321.321,0,0,0,7.179,9.429ZM3.75,6.857H4.821a.321.321,0,0,0,.321-.321V5.464a.321.321,0,0,0-.321-.321H3.75a.321.321,0,0,0-.321.321V6.536A.321.321,0,0,0,3.75,6.857Zm3.429,0H8.25a.321.321,0,0,0,.321-.321V5.464a.321.321,0,0,0-.321-.321H7.179a.321.321,0,0,0-.321.321V6.536A.321.321,0,0,0,7.179,6.857ZM12,13.714H0v-.536a.321.321,0,0,1,.321-.321H.857V2.277A.607.607,0,0,1,1.5,1.714H3.857V.643A.643.643,0,0,1,4.5,0h3a.643.643,0,0,1,.643.643V1.714H10.5a.607.607,0,0,1,.643.563v10.58h.536a.321.321,0,0,1,.321.321ZM1.714,12.857H5.143v-2.25a.321.321,0,0,1,.321-.321H6.536a.321.321,0,0,1,.321.321v2.25h3.429V2.571H8.143V3.643a.643.643,0,0,1-.643.643h-3a.643.643,0,0,1-.643-.643V2.571H1.714ZM7.125,1.714h-.7v-.7A.161.161,0,0,0,6.268.857H5.732a.161.161,0,0,0-.161.161v.7h-.7a.161.161,0,0,0-.161.161v.536a.161.161,0,0,0,.161.161h.7v.7a.161.161,0,0,0,.161.161h.536a.161.161,0,0,0,.161-.161v-.7h.7a.161.161,0,0,0,.161-.161V1.875A.161.161,0,0,0,7.125,1.714Z",
    fill: "#0d47a1"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconHospital);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Icon - hospital.36783bd56829a491419f413a3a63cbf6.svg";